import React, { useRef, useState } from 'react';
import { Market } from 'services/markets.service';
import { DataHook, setupDataFetcher } from './setupDataFetcher';

export type UseMarkets = DataHook<Market[]>;

export function useMarkets(): UseMarkets {
  const [data, setData] = useState<Market[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const disposer = useRef(() => {});

  const setupMarketsFetcher = () => {
    setData([]);
    setLoading(true);
    setError(false);

    const onResult = message => {
      setData(message);
      setLoading(false);
      setError(false);
    };
    const onError = message => {
      console.error(message);
      setError(true);
      setLoading(false);
      disposer.current?.();
    };
    const generateFetchKey = () => 'markets';

    disposer.current = setupDataFetcher({
      onResult,
      onError,
      generateFetchKey,
      maxDataAge: 60000 // 1 mins
    }).disposer;
  };

  React.useEffect(() => {
    setupMarketsFetcher();
    return () => disposer.current?.();
  }, []);

  const refetch = () => {
    disposer.current?.();
    setupMarketsFetcher();
  };

  return {
    data,
    loading,
    error,
    refetch
  };
}
